import { SPECIAL_DATE_RANGES } from '/src/features/_global/constants';
import { fromUnixTime, getUnixTime } from 'date-fns';
import { HOME_DATE_RANGES } from './constants';

export function getHomeSpecialDateRange(rangeValue) {
  if (HOME_DATE_RANGES.includes(rangeValue)) {
    return rangeValue;
  }

  return SPECIAL_DATE_RANGES.RECENT;
}

export function buildHomeDateRange(rangeValue, { getConvertedDateRange, differenceInCalendarDays, subDays }) {
  const special = getHomeSpecialDateRange(rangeValue);
  const { startDate, endDate } = getConvertedDateRange({ special });
  const start = fromUnixTime(startDate);
  const end = fromUnixTime(endDate);
  const durationDays = differenceInCalendarDays(end, start) + 1;
  const previousStartDate = subDays(start, durationDays);
  const previousEndDate = subDays(end, durationDays);

  return {
    start: startDate,
    end: endDate,
    special,
    previousStart: getUnixTime(previousStartDate),
    previousEnd: getUnixTime(previousEndDate),
  };
}
